
import { AlertTriangle } from "lucide-react";
import { ReviewUI } from "@/types/supabase";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import ReviewActionButtons from "./ReviewActionButtons";
import ReportedReasonDisplay from "./ReportedReasonDisplay";
import ContactedProviderBadge from "./ContactedProviderBadge";

interface ReviewCardProps {
  review: ReviewUI;
  onVisibilityToggle: (reviewId: string, isPublic: boolean) => Promise<void>;
  onDeleteReview: (reviewId: string) => void;
  isProcessing: boolean;
}

const ReviewCard = ({ 
  review, 
  onVisibilityToggle, 
  onDeleteReview, 
  isProcessing 
}: ReviewCardProps) => {
  return (
    <Card className={review.isReported ? 'border-red-200' : 'border-gray-200'}>
      <CardHeader className={`pb-4 ${review.isReported ? 'bg-red-50' : ''}`}>
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center">
              <CardTitle className="text-lg font-medium">{review.userName}</CardTitle>
              {review.isReported && (
                <span className="ml-2 text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full flex items-center">
                  <AlertTriangle className="h-3 w-3 mr-1" />
                  Reported
                </span>
              )}
            </div>
            <div className="text-sm text-gray-500 mt-1">
              Rating: {review.rating}/5 • {review.date}
            </div>
            {review.userEmail && (
              <div className="text-sm text-gray-500">
                Email: {review.userEmail}
              </div>
            )}
          </div>
          
          <ReviewActionButtons 
            reviewId={review.id}
            providerId={review.providerId}
            isPublic={review.isPublic}
            onVisibilityToggle={onVisibilityToggle}
            onDeleteReview={onDeleteReview}
            isProcessing={isProcessing}
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="py-2">
          <p className="text-gray-700">{review.comment || "(No comment provided)"}</p>
          
          {review.isReported && review.reportedReason && (
            <ReportedReasonDisplay reason={review.reportedReason} />
          )}
          
          <ContactedProviderBadge contacted={review.isContactedProvider} />
        </div>
      </CardContent>
    </Card>
  );
};

export default ReviewCard;
